import React from "react";
import { Image as ImageIcon, Scissors, LayoutTemplate, Camera } from "lucide-react";
import { FileUpload } from "@/components/FileUpload";
import { BG_GRADIENTS, BG_IMAGES } from "@/lib/gradients";

const chip = "shrink-0 h-9 pl-2.5 pr-3 rounded-full bg-black/45 backdrop-blur-md text-white text-xs font-semibold flex items-center gap-1.5 border border-white/15 active:scale-95 transition-transform";

// Entrée « Galerie » de la feuille ⋯ (changer la photo / vidéo).
export const GalleryRow = ({ onFiles, t }) => (
  <FileUpload accept="image/*,video/*" onFiles={onFiles} variant="custom" testId="story-fs-more-gallery" context="story" allowLargeVideo className="w-full flex items-center gap-3 px-3 py-3 rounded-2xl text-left text-sm font-semibold bg-white/5 active:bg-white/15 transition-colors">
    <ImageIcon size={18} className="opacity-80" /> {t("story.tool_gallery", "Galerie")}
  </FileUpload>
);

// Rangée au-dessus de la barre de publication : Galerie · fonds (story texte) · Extrait (toute vidéo locale ≥ 2 s — lot 613).
export const StoryChipRow = ({ stage, bg, setBg, onFiles, onCamera, canTrim, onTrim, onTemplates, templatesOn = false, t }) => (
  <div className="absolute inset-x-0 z-30 px-3 flex items-center gap-2 overflow-x-auto hide-scrollbar" style={{ bottom: "calc(var(--sa-bottom, 0px) + 76px)" }} data-testid="story-fs-chiprow">
    {onCamera && (
      <button type="button" onClick={onCamera} className={chip} data-testid="story-fs-camera-chip">
        <Camera size={15} /> {t("camera.open", "Caméra")}
      </button>
    )}
    <FileUpload accept="image/*,video/*" onFiles={onFiles} variant="custom" testId="story-fs-gallery" context="story" allowLargeVideo className={chip}>
      <ImageIcon size={15} /> {t("story.tool_gallery", "Galerie")}
    </FileUpload>
    {onTemplates && (
      <button type="button" onClick={onTemplates} aria-pressed={templatesOn} className={chip} style={templatesOn ? { background: "#fff", color: "#111" } : undefined} data-testid="story-fs-templates-chip">
        <LayoutTemplate size={15} /> {t("story.templates", "Modèles")}
      </button>
    )}
    {canTrim && (
      <button type="button" onClick={onTrim} className={chip} data-testid="story-fs-trim-chip">
        <Scissors size={15} /> {t("story.tool_extract", "Extrait")}
      </button>
    )}
    {stage === "text" && (
      <div className="flex items-center gap-2 pl-1" data-testid="story-fs-bg-palette">
        {BG_GRADIENTS.map((g) => (
          <button key={g.key} type="button" onClick={() => setBg(g.key)} aria-label={g.key} className="h-8 w-8 shrink-0 rounded-full border-2 transition-transform active:scale-90" style={{ background: g.css, borderColor: bg === g.key ? "#fff" : "rgba(255,255,255,.35)", transform: bg === g.key ? "scale(1.15)" : "none" }} data-testid={`story-fs-bg-${g.key}`} />
        ))}
        {BG_IMAGES.map((b) => (
          <button key={b.key} type="button" onClick={() => setBg(b.url)} aria-label={b.label} className="h-8 w-8 shrink-0 rounded-full border-2 bg-cover bg-center transition-transform active:scale-90" style={{ backgroundImage: `url(${b.url})`, borderColor: bg === b.url ? "#fff" : "rgba(255,255,255,.35)", transform: bg === b.url ? "scale(1.15)" : "none" }} data-testid={`story-fs-bg-${b.key.replace("img:", "img-")}`} />
        ))}
      </div>
    )}
  </div>
);
